module.exports = __webpack_public_path__ + "assets/img/f3a3410f80da35b47d97e2fd42d43e1e.png";